import React, { useState, useRef } from 'react'
import { Swiper, SwiperSlide } from "swiper/react"
import { Autoplay, EffectFade } from 'swiper'
import "swiper/css"
import "swiper/css/autoplay"
import "swiper/css/effect-fade"
import {map} from 'lodash'

export default ({messages}) => {
  if (!messages || messages.length === 0) return null
  return (
    <div className="bg-sky-600 py-1 px-4 text-white font-semibold text-center text-sm eyeliner-container">
      <Swiper 
        modules={[Autoplay, EffectFade]}
        className="mySwiper"
        loop={true} 
        autoplay={{delay: 3000}}
        speed={1000}
        effect={"fade"}
        fadeEffect={{crossFade: true}}
      >
        {
          map(messages, (msg, index) => {
            return <SwiperSlide key={`banner-message-${index}`}>{msg.message}</SwiperSlide>
          })
        }
      </Swiper>
    </div>
  )
}